import React from 'react';

import {IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {UserThemeConsumer} from '../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {getColorHighlight, getEmojiHighlight} from '../../../helpers/models/highlightHelpers';
import {HighlightBaseModel} from '../../../models/api/highlightBaseModel';
import {NavigationLineEmoji} from '../../common/navigation/navigationLineEmoji';
import {NavigationLineStandardIcon} from '../../common/navigation/navigationLineStandardIcon';

export function renderHighlight(
  tag: HighlightBaseModel,
  isSelected: boolean | undefined,
  isTransparent: boolean,
  iconName?: IconName,
  iconFilledName?: IconName,
) {
  // Emoji highlight.
  const emojiAndSkinTone = getEmojiHighlight(tag);
  if (emojiAndSkinTone) {
    return <NavigationLineEmoji isTransparent={isTransparent} emojiAndSkinTone={emojiAndSkinTone} />;
  }

  // Color highlight or no highlight.
  const colorHighlight = getColorHighlight(tag);

  const filledOrEmptyIcon: IconName = isSelected
    ? iconFilledName ?? 'tagFilledSmall'
    : iconName ?? 'tagSmall';
  return (
    <UserThemeConsumer>
      {(theme) => (
        <NavigationLineStandardIcon
          isTransparent={isTransparent}
          iconName={filledOrEmptyIcon}
          color={colorHighlight && theme.palette[colorHighlight].shade40}
        />
      )}
    </UserThemeConsumer>
  );
}
